<template>
  <div class="App">
    <router-view />
  </div>
</template>

<script>
export default {}
</script>
<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.App {
  color: $color-primary;
  color: var(--color-primary, $color-primary);
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
</style>
